import  React from 'react';
import Link from 'react-router-dom/Link';

// TODO(alcore) Tempoerary, obvioysly.
export default ({event, children, ...props}) =>
    <Link to="#" {...props}>{children}</Link>

/*
export default ({event, parent, children, ...props}) =>
    <Link to={'/wydarzenia/' + (parent ? parent.slug : event.parent.slug) + '/' + event.slug} {...props}>{children}</Link>
*/


// WEBPACK FOOTER //
// ./src/modules/Events/elements/ChildEventLink.js